module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7d88b0bed3af178f580a7432a653488d.png";